import { render, staticRenderFns } from "./BCardCode.vue?vue&type=template&id=4f9f777b&scoped=true&"
import script from "./BCardCode.vue?vue&type=script&lang=js&"
export * from "./BCardCode.vue?vue&type=script&lang=js&"
import style0 from "./BCardCode.vue?vue&type=style&index=0&id=4f9f777b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9f777b",
  null
  
)

export default component.exports